import React from 'react';
import { Button } from '@mui/material';

const ActionButton = ({
  children,
  onClick,
  variant = 'contained',
  color = 'primary',
  startIcon,
  endIcon,
  disabled = false,
  className = '',
  sx = {}
}) => {
  const defaultSx = {
    textTransform: 'uppercase',
    fontWeight: 600,
    fontSize: '0.875rem',
    ...sx
  };

  return (
    <Button
      variant={variant}
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      className={className}
      sx={defaultSx}
    >
      {children}
    </Button>
  );
};

export default ActionButton;
